import React from 'react';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import PropTypes from 'prop-types';
import Container from './Container';

const ChartWrapper = ({ relationship }) => {
  return (
    <IncludedRelationshipProvider
      relationship={relationship}
    >
      <Container />
    </IncludedRelationshipProvider>
  );
};

ChartWrapper.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default ChartWrapper;
